import 'firebase/firestore';
import { JoyField } from 'joy-core';
import { fromFirestoreChangeType } from '../support/FirestoreConversion';
export default class FirestoreCollectionListener {
    constructor(collectionReference, action, conversion) {
        this.collectionReference = collectionReference;
        this.action = action;
        this.conversion = conversion;
        this.unSubscribe = null;
    }
    activate() {
        if (this.unSubscribe !== null) {
            return;
        }
        this.unSubscribe = this.collectionReference.onSnapshot((snapshot) => {
            let data = snapshot.docs.map((docSnapshot, index, _) => {
                return this.conversion(docSnapshot);
            });
            let changes = snapshot.docChanges().map((change, index, _) => {
                let data = new Map();
                data[JoyField.id] = change.doc.id;
                data[JoyField.changeType] = fromFirestoreChangeType(change.type);
                data[JoyField.oldIndex] = change.oldIndex;
                data[JoyField.newIndex] = change.newIndex;
                return data;
            });
            this.action(data, changes);
        }, (error) => {
            console.log(`Encountered snapshot error: ${error}`);
        });
    }
    deactivate() {
        this.unSubscribe();
        this.unSubscribe = null;
    }
}
//# sourceMappingURL=FirestoreCollectionListener.js.map